import { db } from '@/firebase';
import { Apartment } from '@/types';
import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  query,
  orderBy,
} from 'firebase/firestore';

const getApartmentsCollection = (tripId: string) => collection(db, 'trips', tripId, 'apartments');

export const listenToApartments = (tripId: string, callback: (apartments: Apartment[]) => void): (() => void) => {
  const apartmentsCollection = getApartmentsCollection(tripId);
  const apartmentsQuery = query(apartmentsCollection, orderBy('name', 'asc'));
  return onSnapshot(apartmentsQuery, (snapshot) => {
    const apartments = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Apartment));
    callback(apartments);
  });
};

export const addApartment = async (tripId: string, apartment: Omit<Apartment, 'id'>): Promise<string> => {
  const apartmentsCollection = getApartmentsCollection(tripId);
  const docRef = await addDoc(apartmentsCollection, apartment);
  return docRef.id;
};

export const updateApartment = async (tripId: string, apartmentId: string, data: Partial<Apartment>): Promise<void> => {
  if (!apartmentId) throw new Error("Apartment ID is missing");
  const apartmentDoc = doc(db, 'trips', tripId, 'apartments', apartmentId);
  await updateDoc(apartmentDoc, data);
};

export const deleteApartment = async (tripId: string, apartmentId: string): Promise<void> => {
  const apartmentDoc = doc(db, 'trips', tripId, 'apartments', apartmentId);
  await deleteDoc(apartmentDoc);
};
